module.exports = __webpack_public_path__ + "img/icons-travel.0f5c9dbe.png";